module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"placeholder":"댓글을 작성해 주세요.","submit":"등록","cancel":"취소","create_comment_failure":"댓글 작성 중 문제가 발생했습니다.","edit_comment_failure":"댓글 수정 중 문제가 발생했습니다.","confirm_cancel_edit":"댓글 수정을 취소하시겠습니까?"}}')
  delete Component.options._Ctor
}
